/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type ConfigurationCell_DisplayFragment = { __typename: 'Display', id: string, alias?: string | null, configurationSyncStatus?: Types.ConfigurationSyncStatus | null, configuration?: { __typename: 'ConfigurationModel', id: string, name: string } | null };

export const ConfigurationCell_DisplayFragmentDoc = gql`
    fragment ConfigurationCell_display on Display {
  id
  alias
  configuration {
    id
    name
  }
  configurationSyncStatus
}
    `;